export class Color {
    list = ['#000000', '#f7f7f7', '#f7f7f7', '#f7f7f7', '#f7f7f7']; 
    color:String = '000000'; 
    selectItem:number = 0; 
    margin:Number = 0;
    
    constructor () {}
  
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/table/class/color.ts